/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeDialogContext } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React, { createContext, useCallback, useState } from 'react';

const cache = Sebrae.StorageUtil.inTemporaryStore();

export const StepContext = createContext();

const steps = {
  1: 'PROXIMIDADE',
  2: 'AVALIAÇÃO',
  3: 'ADJETIVOS',
};

export const StepProvider = ({ children }) => {
  const [numberStep, setCurrentStep] = useState(1);
  const [hasSendAnswer, setHasSendAnswer] = useState(false);

  // const [formData, setFormData] = useState([]);
  const [formData, setFormData] = useState({
    PROXIMIDADE: [],
    AVALIAÇÃO: [],
    ADJETIVOS: [],
  });
  const [email, setEmail] = useState('');
  const [selectedStorageDefault, setSelectedStorageDefault] = useState(null);

  const { showNotification } = React.useContext(BaSeDialogContext);

  const handleAttention = React.useCallback(
    (msg) => {
      showNotification({
        message: 'Atenção!',
        supportMessage: msg,
        secondsToClose: 3,
        color: 'attention',
      });
    },
    [showNotification],
  );

  const [stages, setStages] = useState([
    { id: 1, nome: 'PROXIMIDADE', passed: false },
    { id: 2, nome: 'AVALIAÇÃO', passed: false },
    { id: 3, nome: 'ADJETIVOS', passed: false },
  ]);

  const updateStageStatus = (stageName) => {
    setStages((prevStages) => {
      return prevStages.map((stage) => {
        if (stage.nome === stageName) {
          return { ...stage, passed: true };
        }
        return stage;
      });
    });
  };

  const goToStage = (stageId) => {
    const selectedStage = stages.find((stage) => stage.id === stageId);

    if (selectedStage) {
      return selectedStage.passed;
    }
    return false;
  };

  const registerCache = useCallback((data, step) => {
    cache.setItem(`@empretec:${steps[step]}`, data);
  }, []);

  const getItemStorage = useCallback((step) => {
    return cache.getItem(`@empretec:${steps[step]}`);
  }, []);

  const loadStorage = React.useCallback(async () => {
    const storedData = await getItemStorage(numberStep);
    if (storedData) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [steps[numberStep]]: storedData,
      }));
    }
  }, [getItemStorage, numberStep]);

  React.useEffect(() => {
    loadStorage();
  }, [loadStorage, stages]);

  const handleDefaltChecked = useCallback((data) => {
    setSelectedStorageDefault(data);
  }, []);

  // // eslint-disable-next-line sonarjs/cognitive-complexity
  // const handleChangeRadio = (idStep, idDoman, optionId) => {
  //   const existingData = formData.find(
  //     (item) => item.idStep === idStep && item.idDoman === idDoman,
  //   );

  //   if (existingData) {
  //     // Atualiza a opção selecionada para o domínio existente
  //     const updatedData = formData.map((item) => {
  //       if (item.idStep === idStep && item.idDoman === idDoman) {
  //         return { ...item, options: [optionId] };
  //       }
  //       return item;
  //     });
  //     setFormData(updatedData);
  //     console.log('updatedData', updatedData);
  //     registerCache(updatedData, idStep);
  //   } else {
  //     // Cria um novo domínio com a opção selecionada
  //     const newData = [...formData, { idStep, idDoman, options: [optionId] }];
  //     setFormData(newData);
  //     console.log('newData', newData);
  //     registerCache(newData, idStep);
  //   }
  // };

  const handleChangeRadio = (idStep, idDoman, optionId) => {
    const existingData = formData[steps[idStep]].find(
      (item) => item.idStep === idStep && item.idDoman === idDoman,
    );

    if (existingData) {
      const updatedData = formData[steps[idStep]].map((item) => {
        if (item.idStep === idStep && item.idDoman === idDoman) {
          return { ...item, options: [optionId] };
        }
        return item;
      });
      setFormData((prevFormData) => ({
        ...prevFormData,
        [steps[idStep]]: updatedData,
      }));
      registerCache(updatedData, idStep);
    } else {
      const newData = [
        ...formData[steps[idStep]],
        { idStep, idDoman, options: [idStep] },
      ];
      setFormData((prevFormData) => ({
        ...prevFormData,
        [steps[idStep]]: newData,
      }));
      registerCache(newData, idStep);
    }
  };

  const handleChangeEmail = useCallback((value) => {
    setEmail(value);
  }, []);

  const validOptionSelected = React.useCallback((obj) => {
    return Object.keys(obj).length === 0;
  }, []);

  const changeHasSendAnswer = React.useCallback(() => {
    setHasSendAnswer((prev) => !prev);
  }, []);

  return (
    <StepContext.Provider
      value={{
        numberStep,
        email,
        formData,
        selectedStorageDefault,
        handleAttention,
        setCurrentStep,
        handleChangeEmail,
        handleChangeRadio,
        getItemStorage,
        setFormData,
        handleDefaltChecked,
        validOptionSelected,
        hasSendAnswer,
        changeHasSendAnswer,
        updateStageStatus,
        goToStage,
        stages,
      }}
    >
      {children}
    </StepContext.Provider>
  );
};
